import { IconButton } from '@epam/uui';
import { Text } from '@epam/promo';
import { ReactComponent as CloseIcon } from '@epam/assets/icons/common/navigation-close-18.svg';
import { ChipsProps } from './Chips.model';
import css from './Chips.module.scss';
import React from 'react';
import { StatusIndicatorDot } from '../StatusIndicator/StatusIndicatorDot';

const Chips = ({
  label,
  status,
  leadingSymbol,
  count,
  onClose,
}: ChipsProps) => (
  <span className={css.chips}>
    {status && (
      <span aria-hidden onClick={() => onClose()}>
        <StatusIndicatorDot size="8" status={status} />
      </span>
    )}
    {leadingSymbol && (
      <span
        aria-hidden
        className={css.chips__leading}
        onClick={() => onClose()}>
        {leadingSymbol}
      </span>
    )}
    <span className={css.chips__label}>
      <Text size="30">{label}</Text>
    </span>
    <span className={css.chips__count}>
      <Text size="24">{count}</Text>
    </span>
    <span>
      <IconButton icon={CloseIcon} onClick={() => onClose()} />
    </span>
  </span>
);

export { Chips };
